<template>
    <div class="projectsList">
        <div class="projectsHead">
            <div class="projectsLogo">开源项目</div>
            <div class="moreProjects" @click="openProject" title="查看更多">查看更多 > </div>
        </div>
        <ul>
            <li v-bind:key="index" v-for="(item, index) in projects">
                <a :href="item.htmlUrl" target="_blank">
                    <p class="title">{{item.name}}</p>
                    <span class="dec">{{item.description}}</span>
                    <div class="pro">
                        <p v-if="item.language"><img src="../../images/语言.svg" />{{item.language}}</p>
                        <p v-if="item.stargazerCount"><img src="../../images/星星.svg" />{{chengeNum(item.stargazerCount)}}</p>
                        <p v-if="item.forkCount"><img src="../../images/代码-分支.svg" />{{chengeNum(item.forkCount)}}</p>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props:['projects', 'sugProjects'],
    methods: {
        openProject(){
           this.$router.push({ name: 'ProjectsList'})
        },
        chengeNum(val){
            let num = parseInt(val);
            if(num < 1000){
                return num;
            }else{
                return  ((num/1000).toFixed(2) + "k");
            }
        }
    },
}
</script>
<style lang="less">
.projectsList{
    max-width: 1320px;
    margin: 30px auto;
    margin-bottom: 0;
    overflow: hidden;
    .projectsHead{
        width: 100%;
        height: 36px;
        margin-bottom: 14px;
        .projectsLogo{
            color: #043483;
            float: left;
            height: 26px;
            line-height: 26px;
            border: 1px solid #043483;
            border-radius: 18px;
            padding: 0 20px;
        }
        .moreProjects{
            height: 36px;
            line-height: 36px;
            float: right;
            cursor: pointer;
            /* text-decoration: underline; */
            color: #043484;
            font-size: 14px;
        }
    }
    ul{
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-gap: 16px;
        margin-bottom: 16px;
        li{
            border: 1px solid #eee;
            padding: 0 0 40px 0;
            list-style-type: none;
            // width: 17.6%;
            // float: left;
            // margin: 18px 0;
            // box-shadow: 5px 5px 5px #eee;
            border-radius: 8px;
            height: 180px;
            a{
               text-decoration: none;
                width: 100%;
                height: 100%;
            }
            .title{
                text-align: center;
                color: #333;
                margin: 20px 0 !important;
                font-size: 16px !important;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 0 20px;
            }

            .dec{
                padding: 5px;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
                height: 100px;
                line-height: 25px;
                padding: 0 10px;
                font-size: 14px;
            }

            .pro{
                height: 30px;
                margin-top: 20px;
                p{
                    max-width: 41%;
                    display: inline-block;
                    height: 20px;
                    line-height: 20px;
                    color: #000;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 13px;
                }
                img{
                    width: 12px;
                    height: 18px;
                    float: left;
                    margin:0 5px 0 10px;
                }
            }

        }
        li:hover{
            border: 1px solid #1595DC;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/common/project-list/index.vue